// extracted by mini-css-extract-plugin
module.exports = {"FullPageLayout":"FullpageLayout_FullPageLayout__1BAyv","NowMoneyLogo":"FullpageLayout_NowMoneyLogo__3TnSl","Outside":"FullpageLayout_Outside__1eRpm"};